import { types } from "./types";

export const actions = {
  updateVariant({ commit }, option) {
    commit(types.UPDATE_VARIANT, option);
  },
};
